import AbstractCRMApi from '../../AbstractCRMApi';

import GetCustomBoxResponse from '../Responses/CustomBox';

import AbstractApi from 'Api/AbstractApi';
import CustomBox from 'Api/Models/CustomBox';

class CustomBoxApi extends AbstractCRMApi {
    public endpoint: string = 'custom_boxes';

    public async getAll(): Promise<GetCustomBoxResponse[]> {
        return (await this.get('')).data;
    }
    public async updateItem(item: CustomBox): Promise<GetCustomBoxResponse> {
        return this.patch(`/${item.id}`, item).then(() => AbstractApi.mapDataToModel(item, CustomBox));
    }
}

export default new CustomBoxApi();
